// C:\Users\User\Desktop\Bresco\bresco-franquicies-frontend\src\components\layout\Navbar\Navbar.js
import { faker } from '@faker-js/faker'
import logoHeader from 'assets/img/Logo-Bresco.png'
import defaultUser from 'assets/img/default-user.jpg'
import { useUser } from 'contexts/UserContext'
import useClickOutside from 'hooks/useClickOutside'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { LuPanelLeftClose, LuPanelLeftOpen } from 'react-icons/lu'
import { useLocation } from 'wouter'
import Title from '../Title/Title'

export default function Navbar({ isSidebarOpen, setIsSidebarOpen }) {
  const { user } = useUser()
  const [, setLocation] = useLocation()

  const dropRef = useClickOutside(() => setOpenUserDropdown(false))
  const [darkTheme, setDarkTheme] = useState(false)
  const [openUserDropdown, setOpenUserDropdown] = useState(false)

  // eslint-disable-next-line no-unused-vars
  const image = faker.image.url()

  return (
    <nav
      className={`z-50 fixed h-20 ${
        isSidebarOpen ? 'pl-0 md:pl-60' : 'pl-0 md:pl-24'
      } flex justify-center items-center top-0 w-full bg-[#5362AC] dark:bg-[#38393D] duration-100`}
    >
      <div className="flex items-center justify-between w-full px-4 py-2 mx-auto md:py-0">
        {/* IZQUIERDA: logo header + toggle + title */}
        <div>
          <div className="flex flex-row items-center justify-center m-0">
            {/* Logo en header (siempre visible, especialmente en móvil) */}
            <img
              src={logoHeader}
              alt="Bresco"
              className="h-10 w-auto mr-3 select-none"
              draggable="false"
            />

            {/* Toggle sidebar (solo móvil) */}
            <div className="md:hidden pr-2 flex flex-row items-center justify-center m-0">
              {!isSidebarOpen ? (
                <LuPanelLeftOpen
                  className="text-white cursor-pointer hover:text-[#FCAE52]"
                  size={30}
                  onClick={() => setIsSidebarOpen((prev) => !prev)}
                />
              ) : (
                <LuPanelLeftClose
                  className="text-white cursor-pointer hover:text-[#FCAE52]"
                  size={30}
                  onClick={() => setIsSidebarOpen((prev) => !prev)}
                />
              )}
            </div>

            <Title />
          </div>
        </div>

        {/* DERECHA: usuario */}
        <div className="flex flex-row items-center justify-end space-x-9">
          <div
            ref={dropRef}
            className="flex flex-col items-center space-x-3 md:order-2 md:space-x-0 rtl:space-x-reverse"
          >
            <button
              type="button"
              className="flex text-sm rounded-full md:me-0 focus:ring-opacity-90 focus:outline-none focus:ring focus:ring-gray-500 focus:border-gray-500 dark:focus:border-gray-500"
              onClick={() => setOpenUserDropdown((prev) => !prev)}
            >
              <img
                className="object-cover w-12 h-12 rounded-full"
                src={user?.profile_picture || defaultUser}
                alt=""
              />
            </button>

            <div
              className={`absolute top-14 right-4 z-50 ${
                !openUserDropdown && 'hidden'
              } my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600`}
            >
              <div className="px-4 py-3">
                <span className="block text-sm text-gray-900 dark:text-white">
                  {user?.first_name + ' ' + user?.last_name}
                </span>

                <span className="block text-sm text-gray-500 truncate dark:text-gray-400">
                  {user?.username}
                </span>
              </div>

              <ul className="py-2">
                <li>
                  <label className="inline-flex items-center px-4 py-2 cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      onClick={(e) => {
                        e.stopPropagation()
                        document.body.classList.toggle('dark')
                        setDarkTheme((prev) => !prev)
                      }}
                    />

                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>

                    <span className="text-sm text-gray-700 dark:text-gray-200 ms-3">
                      {darkTheme ? 'Tema oscuro' : 'Tema claro'}
                    </span>
                  </label>
                </li>

                <li>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                    onClick={() => setLocation('/logout')}
                  >
                    Cerrar sesión
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

Navbar.propTypes = {
  isSidebarOpen: PropTypes.any,
  setIsSidebarOpen: PropTypes.func
}
